// FILE: useTutorialVideos.js
// Hook for managing tutorial video links

const useTutorialVideos = () => {
    const tutorialVideos = {
        "Adding Students": {
            id: "adding-students",
            title: "Adding Students",
            description: "Learn how to add and manage students in your classroom",
            embedCode: `<iframe width="560" height="315" src="https://www.youtube.com/embed/dq-d0wbYstw?si=4dJVAa5byPbCHueK" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`, // Replace with actual embed code
            duration: "1 min"
        },
        "Creating Subjects": {
            id: "creating-subjects",
            title: "Creating Subjects",
            description: "Set up subjects and organize your curriculum",
            embedCode: `<iframe width="560" height="315" src="https://www.youtube.com/embed/2c-YVkSXLXc?si=T14zZcyp58OqmMLr" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`, // Replace with actual embed code
            duration: "1 min"
        },
        "Generating Comments-Single Student": {
            id: "generating-comments-single",
            title: "Generating Comments-Single Student",
            description: "Generate personalized AI comments for individual students",
            embedCode: `<iframe width="560" height="315" src="https://www.youtube.com/embed/GCdNear8c3g?si=18qogriQ0tuXi7k8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`, // Replace with actual embed code
            duration: "2 min"
        },
        "Generating Comments-Multiple Students": {
            id: "generating-comments-multiple",
            title: "Generating Comments-Multiple Students",
            description: "Efficiently generate AI comments for multiple students at once",
            embedCode: `<iframe width="560" height="315" src="https://www.youtube.com/embed/CuImNvackzw?si=hUv6ipsN4BQ6d3zh" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`, // Replace with actual embed code
            duration: "2 min"
        },
        "Adding Units": {
            id: "adding-units",
            title: "Adding Units",
            description: "Create and organize curriculum units within subjects",
            embedCode: `<iframe width="560" height="315" src="https://www.youtube.com/embed/5TRVJn9PiYE?si=e6stCSgFberPz-Ms" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`, // Replace with actual embed code
            duration: "1 min"
        },
        "Creating DOK Skills": {
            id: "creating-dok-skills",
            title: "Creating DOK Skills",
            description: "Set up Depth of Knowledge skills for assessment tracking",
            embedCode: `<iframe width="560" height="315" src="https://www.youtube.com/embed/YBx27J20uU8?si=_us0QeP0VD2YC1q9" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`, // Replace with actual embed code
            duration: "2 min"
        },
        "Recording assessment for single student": {
            id: "ra-assessment-s",
            title: "Recording assessment for single student",
            description: "Record assessment for single student. This will be used to generate comment",
            embedCode: `<iframe width="560" height="315" src="https://www.youtube.com/embed/yeAvKR-oe6Q?si=Wc6Io-IXrI1e5po4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`, // Replace with actual embed code
            duration: "2 min"
        }
        ,
        "Recording assessment for multiple students": {
            id: "ra-assessment-m",
            title: "Creating DOK Skills",
            description: "Set up Depth of Knowledge skills for assessment tracking",
            embedCode: `<iframe width="560" height="315" src="https://www.youtube.com/embed/8Dyk7FEOOus?si=rDYXCA8DrBrgABDt" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`, // Replace with actual embed code
            duration: "2 min"
        }
    };

    // Helper function to extract src URL from embed code and add highest quality
    const extractSrcFromEmbed = (embedCode) => {
        if (!embedCode) return null;
        const srcMatch = embedCode.match(/src="([^"]+)"/);
        if (srcMatch && srcMatch[1]) {
            // Add parameters for better quality and autoplay
            const url = srcMatch[1];
            const separator = url.includes('?') ? '&' : '?';
            return `${url}${separator}hd=1&rel=0&modestbranding=1`;
        }
        return null;
    };

    // Helper function to get video by title
    const getVideoByTitle = (title) => {
        const video = tutorialVideos[title];
        if (video) {
            return {
                ...video,
                videoUrl: extractSrcFromEmbed(video.embedCode)
            };
        }
        return null;
    };

    // Helper function to get video by ID
    const getVideoById = (id) => {
        return Object.values(tutorialVideos).find(video => video.id === id) || null;
    };

    // Get all videos as array
    const getAllVideos = () => {
        return Object.values(tutorialVideos);
    };

    // Get video titles
    const getVideoTitles = () => {
        return Object.keys(tutorialVideos);
    };

    return {
        tutorialVideos,
        getVideoByTitle,
        getVideoById,
        getAllVideos,
        getVideoTitles
    };
};

export default useTutorialVideos;